import React from 'react';

import {Props} from './model';
import {useDeviceSize, DeviceSize} from '../../../../shared/theme/helpers';

import {useStyles} from '../../../../shared/hooks/styles';
import {GradientView} from '../../../../shared/components/gradientView';
import {hexToRgbA} from '../../../../shared/pipes/color';
import {useTheme} from '../../../../shared/theme';
import {Text} from '../../../../shared/components/text';

export default (props: Props) => {
  const deviceSize = useDeviceSize();
  const theme = useTheme();
  const styles = useStyles(() => {
    return {
      text: {
        color: theme.color.mainPageTextNameColor,
        marginBottom: 31,
      },
      mobileText: {
        color: theme.color.whiteTextColor,
        paddingVertical: 18,
        marginHorizontal: 16,
        textAlign: 'center',
      },
      gradientContainer: {
        marginHorizontal: -16,
        backgroundColor: theme.color.primaryColor,
      },
    };
  });

  if (deviceSize === DeviceSize.desktop) {
    return (
      <Text testID='desktop-hello-name-id' type='h5Light' style={styles.text}>
        Здравствуйте, {props.name}!
      </Text>
    );
  }
  return (
    <GradientView
      gradient={{angle: 90, colors: theme.welcome.bgGradient.map((color) => hexToRgbA(color, 0.9))}}
      style={styles.gradientContainer}>
      <Text testID='mobile-hello-name-id' type='h6Light' style={styles.mobileText}>
        Здравствуйте, {props.name}!
      </Text>
    </GradientView>
  );
};
